var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{ref:"toolbar",class:_vm.b('filters-card')},[_vm._t("filters")],2),_c('v-container',{class:_vm.b('body'),attrs:{"fluid":""}},[_vm._t("default")],2),_c('v-btn',{class:_vm.b('fab'),attrs:{"fab":"","color":"primary"},on:{"click":_vm.onClickFab}},[_c('v-icon',[_vm._v("mdi-filter-outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }